import React from 'react'
import { Typography } from '@material-ui/core'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import { useIntl } from 'react-intl'
import utilityConfig from 'app/configs/utilityConfigs'
import { useBreakpoints } from 'commons/useBreakpoints'

const useStyles = makeStyles((theme) => ({
  darkGreyBlueText: {
    color: theme.palette.darkGreyBlue.main,
  },
  text: {
    [useBreakpoints(theme).lessThan.md]: {
      maxWidth: '270px',
    },
  },
}))

const AuthenticateCardFooter = () => {
  const classes = useStyles()
  const { formatMessage } = useIntl()
  return (
    <div className="flex inline-flex justify-center w-full">
      <Typography
        className={clsx(classes.darkGreyBlueText, classes.text, 'text-center')}
      >
        {formatMessage(
          {
            id: 'registerSuccess.footer',
          },
          {
            linkEmail: (
              <a
                href={`mailto:${utilityConfig.supportUrl}`}
                className={clsx(classes.linkColor, 'ltr:pl-4 rtl:pr-4')}
              >
                {utilityConfig.supportUrl}
              </a>
            ),
          },
        )}
      </Typography>
    </div>
  )
}

export default AuthenticateCardFooter
